/**
 * Rosie — NEMT Dispatch Platform
 * Copyright (c) 2025-2026 Commonwealth Transport LLC. All rights reserved.
 * PROPRIETARY AND CONFIDENTIAL. Unauthorized use, copying, or distribution is prohibited.
 */
import React, { useState } from 'react';
import api from '../utils/api';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await api.post('/auth/login', { email, password });
      localStorage.setItem('nemt_token', res.data.token);
      localStorage.setItem('nemt_user', JSON.stringify(res.data.user));
      // Return to the page they were on (e.g. a bookmarked room) if the
      // interceptor stashed one; otherwise land on Today.
      const returnTo = localStorage.getItem('nemt_return_to');
      localStorage.removeItem('nemt_return_to');
      window.location.href = returnTo || '/';
    } catch (err) {
      setError('Invalid email or password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center',
      justifyContent: 'center', background: '#f5f5f3'
    }}>
      <div style={{
        background: 'white', borderRadius: 12, border: '0.5px solid #e0e0db',
        padding: '2rem', width: '100%', maxWidth: 380
      }}>
        <div style={{ marginBottom: '1.5rem' }}>
          <h1 style={{ fontSize: 20, fontWeight: 500, margin: 0 }}>Commonwealth NEMT</h1>
          <p style={{ fontSize: 13, color: '#888', margin: '4px 0 0' }}>Sign in to dispatch</p>
        </div>

        {error && (
          <div style={{
            background: '#FCEBEB', color: '#A32D2D', padding: '8px 12px',
            borderRadius: 8, fontSize: 13, marginBottom: 16
          }}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 12 }}>
            <label style={{ fontSize: 12, color: '#666', display: 'block', marginBottom: 4 }}>Email</label>
            <input
              type="email" value={email}
              onChange={e => setEmail(e.target.value)}
              style={{ width: '100%' }}
              required
            />
          </div>
          <div style={{ marginBottom: 20 }}>
            <label style={{ fontSize: 12, color: '#666', display: 'block', marginBottom: 4 }}>Password</label>
            <input
              type="password" value={password}
              onChange={e => setPassword(e.target.value)}
              style={{ width: '100%' }}
              required
            />
          </div>
          <button type="submit" disabled={loading} style={{ width: '100%' }}>
            {loading ? 'Signing in...' : 'Sign in'}
          </button>
        </form>
      </div>
    </div>
  );
}